module.exports = __webpack_public_path__ + "img/underwater-world.b8bd0540.webp";